/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import CursosProfesor from './CursosProfesor';
import {bindActionCreators} from 'redux';
import * as paginaActions from '../../actions/paginaActions';

import {Auth} from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react'
import toastr from 'toastr';
import * as menuActions from '../../actions/menuActions'; 
import * as userActions from '../../actions/userActions';
import * as cursoActions from '../../actions/cursoActions';
import { Segment} from 'semantic-ui-react';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as usuarioActions from '../../actions/usuarioActions';
import * as usuariocursoActions from '../../actions/usuariocursoActions';

import {getMargenes, getMargenesBlack} from '../../util/';
import {usuarioActual} from '../../util';

class ManageCursosProfesor extends React.Component {
    
    constructor(props, context) {
		super(props, context);
        this.state={
            errors:{},
            strings:{},
            modulos:{},
            cursos:[]
        };
	}
 
   componentDidMount(){
        usuarioActual(this, "reporte",true).then( (usuario)=>{
            
            this.props.cursoActions.getCursosProfesor(usuario).then((cursos)=>{
                
                this.setState({cursos:cursos});
            }) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 
            
           
            
           
	   })
    }
    
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		
		return (
            
            <Segment style={margenes} >
                  
                <CursosProfesor
                    modulos={this.state.modulos}
                    strings={this.props.strings}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    permisos={this.state.permisos}
                    userInfo={this.state.userInfo}
                    cursoCombo={this.props.cursoCombo}
                    cursos={this.state.cursos}
                />
            
            </Segment> 
            
		);
	}
    
    
}

function mapStateToProps(state, ownProps){
    return {   
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        strings:state.strings,
        idioma:state.idioma,
        menu:state.menu,
        user:state.user,
        cursoCombo:state.cursoCombo,
    }

}

function mapDispatchToProps(dispatch){

	return {  
        menuActions: bindActionCreators(menuActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        usuarioActions: bindActionCreators(usuarioActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
 	};
}


export default connect (mapStateToProps, mapDispatchToProps)(withAuthenticator(ManageCursosProfesor));